import { LayoutDashboard, Package, ShoppingCart, LogOut, Store, Zap, Layers } from 'lucide-react';

export default function Sidebar({ activeTab, setActiveTab, onLogout }) {
  const menuItems = [
    { id: 'dashboard', label: 'Tổng Quan', icon: LayoutDashboard },
    { id: 'categories', label: 'Quản Lý Danh Mục', icon: Layers },
    { id: 'products', label: 'Quản Lý Sản Phẩm', icon: Package },
    { id: 'orders', label: 'Quản Lý Đơn Hàng', icon: ShoppingCart },
    { id: 'flash-sale', label: 'Quản Lý Flash Sale', icon: Zap }, // Thêm mục Flash Sale tại đây
  ];

  return (
    <aside className="w-64 bg-slate-900 text-slate-300 min-h-screen p-6 flex flex-col justify-between border-r border-slate-800">
      <div className="space-y-8">
        <div className="flex items-center space-x-2 px-2">
          <span className="text-xl font-bold text-white font-serif">
            JapanICHIBA<span className="text-indigo-500">Admin.</span>
          </span>
        </div>

        <nav className="space-y-1.5">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = activeTab === item.id;
            return (
              <button
                key={item.id}
                onClick={() => setActiveTab(item.id)}
                className={`w-full flex items-center space-x-3 px-4 py-3 rounded-xl text-xs font-bold transition ${
                  isActive
                    ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-600/30'
                    : 'text-slate-400 hover:bg-slate-800 hover:text-white'
                }`}
              >
                <Icon className="w-4 h-4" />
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>
      </div>

      <div className="pt-6 border-t border-slate-800 space-y-2">
        <a
          href="/"
          className="w-full flex items-center space-x-3 px-4 py-3 rounded-xl text-xs font-bold text-slate-400 hover:bg-slate-800 hover:text-white transition"
        >
          <Store className="w-4 h-4" />
          <span>Xem Cửa Hàng</span>
        </a>
        <button
          onClick={onLogout}
          className="w-full flex items-center space-x-3 px-4 py-3 rounded-xl text-xs font-bold text-rose-400 hover:bg-rose-500/10 transition"
        >
          <LogOut className="w-4 h-4" />
          <span>Đăng Xuất</span>
        </button>
      </div>
    </aside>
  );
}